export enum AboBuchungDetailedStatus {
  INBUCHUNG = "INBUCHUNG", 
  INBEZAHLUNG = "INBEZAHLUNG", 
  AKTIV = "AKTIV", 
  CANCELED = "CANCELED", 
  REFUNDED = "REFUNDED", 
  WARTE_AUF_ABOZAHLUNG = "WARTE_AUF_ABOZAHLUNG", 
  UNBEKANNT = "UNBEKANNT", 
  CANCELED_BETREIBER = "CANCELED_BETREIBER"
}